import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Play, Sparkles } from "lucide-react";

const HERO_IMAGE = "hero2.webp";

export const HeroSection = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
       <img
  src={HERO_IMAGE}
  alt="Digital Agency in Vancouver"
  className="absolute inset-0 h-full w-full object-cover"
/>
        {/* <div className="absolute inset-0 bg-gradient-to-br from-foreground/95 via-foreground/90 to-foreground/80" /> */}

        {/* <motion.div
          className="hidden sm:block absolute top-12 right-8 md:top-16 md:right-16 w-56 h-56 md:w-80 md:h-80 rounded-full opacity-30"
          style={{
            background:
              "radial-gradient(circle, hsl(var(--primary)) 0%, transparent 70%)",
          }}
          animate={{ scale: [1, 1.2, 1], x: [0, 30, 0], y: [0, -20, 0] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="hidden sm:block absolute bottom-10 left-8 md:bottom-16 md:left-16 w-44 h-44 md:w-64 md:h-64 rounded-full opacity-20"
          style={{
            background:
              "radial-gradient(circle, hsl(var(--secondary)) 0%, transparent 70%)",
          }}
          animate={{ scale: [1, 1.3, 1], x: [0, -20, 0], y: [0, 30, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        /> */}
      </div>

     <div className="container-custom relative z-10 px-5 pt-[20px] pb-[44px] sm:px-5 sm:pt-[90px] sm:pb-[56px] lg:pt-[60px] lg:pb-[88px]">
        <div className="grid items-center gap-14 lg:grid-cols-[1.1fr_0.9fr]">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            {/* Eyebrow */}
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="mb-5 sm:mb-2 flex justify-center lg:justify-start"
            >
              <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/20 px-3 py-2 sm:px-4">
                <Sparkles className="h-4 w-4 text-primary-foreground" />
                <span className="text-sm font-medium text-primary-foreground">
                  Digital Agency in Vancouver
                </span>
              </div>
            </motion.div>

            {/* Headline */}
            <motion.h1
              initial={{ opacity: 0, y: 26 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className='m-0 mb-[18px] max-w-[760px] font-["Lato",system-ui,sans-serif] text-[clamp(2.2rem,4vw,3rem)] font-extrabold leading-[1.15] text-background mx-auto lg:mx-0'
            >
              Digital Agency in Vancouver That Builds What Your Business{" "}
              <span className="gradient-text">Actually Needs Online</span>
            </motion.h1>

            {/* Main supporting line */}
            <motion.p
              initial={{ opacity: 0, y: 26 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="m-0 mb-3 max-w-[560px] text-[1.08rem] font-medium leading-[1.7] text-white/85 backdrop-blur-[2px] drop-shadow-[0_2px_8px_rgba(0,0,0,0.45)] mx-auto lg:mx-0"
            >
              Website development, SEO, social media, and custom tools — built
              around your business goals, not a generic package.
            </motion.p>

            {/* Helper line */}
            {/* <motion.p
              initial={{ opacity: 0, y: 26 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.25 }}
              className="m-0 mb-6 max-w-[560px] rounded-xl bg-black/18 px-4 py-3 text-[0.95rem] italic leading-[1.65] text-white/85 backdrop-blur-[2px] drop-shadow-[0_2px_8px_rgba(0,0,0,0.45)] mx-auto lg:mx-0"
            >
              We plan, build, and improve digital experiences that support real
              growth—not one-size-fits-all marketing.
            </motion.p> */}

            {/* CTAs */}
            <motion.div
              initial={{ opacity: 0, y: 26 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center justify-center lg:justify-start gap-[14px]"
            >
              <Button
                variant="gradient"
                asChild
                className="group inline-flex min-h-[52px] w-full sm:w-auto items-center justify-center rounded-[10px] px-7 py-[14px] text-[1rem] font-bold"
              >
                <Link
                  to="/contact"
                  className="flex items-center justify-center gap-2"
                >
                  Book a Free Consultation
                  <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button
                variant="glass"
                asChild
                className="inline-flex min-h-[52px] w-full sm:w-auto items-center justify-center rounded-[10px] border border-white/20 bg-white/10 px-7 py-[14px] text-[1rem] font-bold text-white transition-all duration-300 hover:-translate-y-[2px] hover:bg-white/10 hover:shadow-[0_8px_30px_rgba(255,255,255,0.12)]"
              >
                <Link
                  to="/work"
                  className="flex items-center justify-center gap-2"
                >
                  <Play className="h-5 w-5" />
                  View Our Work
                </Link>
              </Button>
            </motion.div>

            {/* Note */}
            {/* <motion.p
              initial={{ opacity: 0, y: 26 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.35 }}
              className="m-0 mt-[14px] max-w-[480px] text-[0.88rem] leading-[1.7] text-white/85 backdrop-blur-[2px] drop-shadow-[0_2px_8px_rgba(0,0,0,0.45)] mx-auto lg:mx-0"
            >
              Services depend on your business goals, timeline, and project
              requirements.
            </motion.p> */}
          </div>

          <div className="hidden lg:flex items-center justify-center min-h-[420px]">
            <div className="h-[420px] w-full max-w-[520px]" />
          </div>
        </div>
      </div>
    </section>
  );
};